import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
export default function () {
    function onClick1(handlePageClick, handleFirstPageClick, handleLastPageClick, handleNextPageClick, handlePreviousPageClick, activePage, activePages, color, totalPages) {
        handleFirstPageClick();
    }
    function onClick2(handlePageClick, handleFirstPageClick, handleLastPageClick, handleNextPageClick, handlePreviousPageClick, activePage, activePages, color, totalPages) {
        handlePreviousPageClick();
    }
    function onClick3(handlePageClick, handleFirstPageClick, handleLastPageClick, handleNextPageClick, handlePreviousPageClick, activePage, activePages, color, totalPages, page, pageIndex) {
        handlePageClick(page, pageIndex);
    }
    function repeatPage4(handlePageClick, handleFirstPageClick, handleLastPageClick, handleNextPageClick, handlePreviousPageClick, activePage, activePages, color, totalPages, page, pageIndex) {
        return React.createElement('li', {
            'className': classNames('ui-pagination-list-item', { 'ui-pagination-list-item--active': activePage === page }),
            'key': pageIndex,
            'onClick': onClick3.bind(this, handlePageClick, handleFirstPageClick, handleLastPageClick, handleNextPageClick, handlePreviousPageClick, activePage, activePages, color, totalPages, page, pageIndex)
        }, '\r\n        ', page, '\r\n      ');
    }
    function onClick5(handlePageClick, handleFirstPageClick, handleLastPageClick, handleNextPageClick, handlePreviousPageClick, activePage, activePages, color, totalPages) {
        handleNextPageClick();
    }
    function onClick6(handlePageClick, handleFirstPageClick, handleLastPageClick, handleNextPageClick, handlePreviousPageClick, activePage, activePages, color, totalPages) {
        handleLastPageClick();
    }
    function scopeHandlePageClickHandleFirstPageClickHandleLastPageClickHandleNextPageClickHandlePreviousPageClickActivePageActivePagesColorTotalPages7() {
        var handlePageClick = this.handlePageClick;
        var handleFirstPageClick = this.handleFirstPageClick;
        var handleLastPageClick = this.handleLastPageClick;
        var handleNextPageClick = this.handleNextPageClick;
        var handlePreviousPageClick = this.handlePreviousPageClick;
        var activePage = this.state.activePage;
        var activePages = this.state.activePages;
        var color = this.props.color;
        var totalPages = this.props.totalPages;
        return React.createElement('div', {}, React.createElement('div', { 'className': classNames('ui-pagination', { 'ui-pagination--green': color === 'green' }) }, React.createElement('div', {
            'className': 'ui-pagination-text',
            'onClick': onClick1.bind(this, handlePageClick, handleFirstPageClick, handleLastPageClick, handleNextPageClick, handlePreviousPageClick, activePage, activePages, color, totalPages)
        }, React.createElement(FormattedMessage, { 'id': 'pagination.firstPage' })), totalPages > 10 ? React.createElement('div', {
            'className': 'ui-pagination-arrow-left',
            'onClick': onClick2.bind(this, handlePageClick, handleFirstPageClick, handleLastPageClick, handleNextPageClick, handlePreviousPageClick, activePage, activePages, color, totalPages),
            'key': '897'
        }) : null, React.createElement.apply(this, [
            'ul',
            { 'className': 'ui-pagination-list' },
            _.map(activePages, repeatPage4.bind(this, handlePageClick, handleFirstPageClick, handleLastPageClick, handleNextPageClick, handlePreviousPageClick, activePage, activePages, color, totalPages))
        ]), totalPages > 10 ? React.createElement('div', {
            'className': 'ui-pagination-arrow-right',
            'onClick': onClick5.bind(this, handlePageClick, handleFirstPageClick, handleLastPageClick, handleNextPageClick, handlePreviousPageClick, activePage, activePages, color, totalPages),
            'key': '1362'
        }) : null, React.createElement('div', {
            'className': 'ui-pagination-text',
            'onClick': onClick6.bind(this, handlePageClick, handleFirstPageClick, handleLastPageClick, handleNextPageClick, handlePreviousPageClick, activePage, activePages, color, totalPages)
        }, React.createElement(FormattedMessage, { 'id': 'pagination.lastPage' }))));
    }
    return scopeHandlePageClickHandleFirstPageClickHandleLastPageClickHandleNextPageClickHandlePreviousPageClickActivePageActivePagesColorTotalPages7.apply(this, []);
}